import { Inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { EIDSDK } from '../providers/eid-sdk.provider';
import { LOGOUT_REQUESTED_MESSAGE } from '@app/shared/auth-broadcast-channel';
import { TokenStorageService } from '@app/shared/services/token-storage.service';

@Injectable({
  providedIn: 'root'
})
export class EidSessionService {
  private readonly authBroadcastChannel: BroadcastChannel;
  private logoutHandled = false;
  private isManualLogout = false;

  constructor(
    @Inject(EIDSDK) private readonly eid: any,
    private readonly cookieService: CookieService,
    private readonly tokenStorage: TokenStorageService
  ) {
    this.authBroadcastChannel = new BroadcastChannel('auth-channel');

    this.authBroadcastChannel.onmessage = async (event) => {
      const isEidEnabled = this.tokenStorage.userInfo?.CurrentSite?.PowerSuitEidAuthEnabled;
      if (!isEidEnabled) {
        return;
      }

      // Ignore broadcast if this tab initiated manual logout
      if (this.isManualLogout) {
        console.log('[EID Session Service] Ignoring broadcast - manual logout in progress');
        this.isManualLogout = false;  // Reset flag
        return;
      }

      if (event.data === LOGOUT_REQUESTED_MESSAGE && !this.logoutHandled) {
        this.logoutHandled = true;
        console.log('[EID Session Service] Received session timeout broadcast, redirecting to EID login');
        try {
          await this.eid.oidc.signOut({ extraQueryParams: { reason: 'idle' } });
        } catch (error) {
          console.error('[EID Session Service] Error during signOut:', error);
        }
      }
    };
  }

  public setManualLogoutFlag(): void {
    this.isManualLogout = true;
  }

  public async handleSession(): Promise<void> {
    this.logoutHandled = false;
    this.isManualLogout = false;

    this.cookieService.set('eidSession', 'true', undefined, '/');

  }

}